import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Log environment configuration
console.log('=================================');
console.log('ADMIN APP ENVIRONMENT:');
console.log('API Base URL:', process.env.REACT_APP_API_BASE_URL || 'http://localhost:3800');
console.log('Using .env.local:', process.env.REACT_APP_API_BASE_URL === 'http://localhost:3800' ? 'YES' : 'NO (using .env)');
console.log('=================================');

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();
